import * as React from 'react'
import ItineraryModel from '../../models/ItineraryModel'
import { useSelector } from 'react-redux'
import { Buttons, Col, Container, FieldFooter, FormFieldLabel, FormFieldWrapper, Grid, IdFormField, LabelFormField, MapsRoutesPreview, MediaSelector, Photo, Row, TextAreaField, TextFormField, TimePickerFormFieldController, Tooltip, guid, indexDown, indexUp, minutesToTimeString, nameof, timeStringToMinutes } from 'traveldesk-ui'
import { Controller, useForm } from 'react-hook-form'
import ItineraryStopModel from '../../models/ItineraryStopModel'
import { MapsLocationPicker } from 'traveldesk-ui'
import { MapsLocation } from 'traveldesk-ui'
import { GLOBAL_SETTINGS } from '../..'
import { ApplicationState } from '../../store'
import blobToBase64 from '../../utils/blobToBase64'
import ItineraryStopPhotoModel from '../../models/ItineraryStopPhotoModel'
interface Props {
    itinerary: ItineraryModel
    onChange: (itinerary: ItineraryModel) => void
}
const routeMapcontainerStyle = {
    width: '100%',
    height: '200px'
};
const ItineraryDesigner = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const itinerary = props.itinerary
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        getValues,
        setValue,
        watch,
        reset,
        setError,
    } = useForm()
    const onSubmit = (data: any) => {
        props.onChange(data)
    }
    const getStopsFieldsNames = (index: number) => {
        return {
            index: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('index')}`,
            name: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('name')}`,
            description: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('description')}`,
            time: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('time')}`,
            timeEnd: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('timeEnd')}`,
            timeDescription: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('timeDescription')}`,
            timeEndDescription: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('timeEndDescription')}`,
            address: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('address')}`,
            lat: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('lat')}`,
            lng: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('lng')}`,
            heroImageId: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('heroImageId')}`,
            heroImage: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('heroImage')}`,
            photos: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('photos')}`,
            mapLocationPhotoBase64: `${nameof<ItineraryModel>('stops')}[${index}].${nameof<ItineraryStopModel>('mapLocationPhotoBase64')}`,

        }
    }
    const setLocationPhoto = async (fName: string, location: MapsLocation) => {
        if (location.lat && location.lng) {
            const response = await fetch(`https://maps.googleapis.com/maps/api/staticmap?center=${location.lat},${location.lng}&zoom=13&size=1000x1000&maptype=roadmap&markers=color:red%7C${location.lat},${location.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`)
            const blob = await response.blob()
            const base64 = await blobToBase64(blob)
            setValue(fName, base64)
        }
        else {
            setValue(fName, "")
        }
    }
    const stops = watch('stops') as ItineraryStopModel[]
    const onSelectStopPhotos = (stopGuid: string, photos: Photo[]) => {
        const data = { ...getValues() } as ItineraryModel
        data.stops = data.stops.map(stop => {
            if (stop.guid != stopGuid) return stop
            stop.photos = (stop.photos ?? []).concat(photos.map(x => Object.assign(
                new ItineraryStopPhotoModel(), {
                itineraryStopGuid: stop.guid,
                photoId: x.id,
                photo: x
            })))
            if (!stop.heroImageId && stop.photos.length > 0) {
                stop.heroImageId = stop.photos[0].photoId
                stop.heroImage = stop.photos[0].photo
            }
            return stop
        })
        reset(data)
    }
    const onDeleteStopPhotos = (stopGuid: string, id: number) => {
        const data = { ...getValues() } as ItineraryModel
        data.stops = data.stops.map((stop: ItineraryStopModel) => {
            if (stop.guid != stopGuid) return stop
            stop.photos = stop.photos.filter(x => x.photoId != id)
            if (stop.heroImageId == id) {
                if (stop.photos.length > 0) {
                    stop.heroImageId = stop.photos[0].photoId
                    stop.heroImage = stop.photos[0].photo
                }
                else {
                    stop.heroImageId = undefined
                    stop.heroImage = undefined
                }
            }
            return stop
        })
        reset(data)
    }
    const onAddStop = () => {
        const data = { ...getValues() } as ItineraryModel
        if (!data.stops) data.stops = []
        data.stops.push(new ItineraryStopModel(data.stops.length + 1, data.id))
        reset(data)
    }
    const onDeleteStop = (index: number) => {
        const data = { ...getValues() } as ItineraryModel
        data.stops = data.stops.filter(x => x.index != index).map((x, i) => {
            x.index = i + 1
            x.guid = x.guid || guid()
            return x
        })
        reset(data)
    }
    const onStopUp = (index: number) => {
        const data = { ...getValues() } as ItineraryModel
        data.stops = indexUp(data.stops, index)
        reset(data)
    }
    const onStopDown = (index: number) => {
        const data = { ...getValues() } as ItineraryModel
        data.stops = indexDown(data.stops, index)
        reset(data)
    }

    React.useEffect(() => {
        if (props.itinerary != null && props.itinerary.stops.length == 0) {
            onAddStop()
        }
    }, [])
    React.useEffect(() => {
        reset(props.itinerary)
    }, [props.itinerary])
    return <Grid>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Row style={itinerary.stops?.length > 0 ? { marginBottom: '0px' } : {}}>
                <Col type="100">
                    <IdFormField control={control} />
                    <TextFormField
                        label={Localization.getString('Itinerary Name')}
                        isRequired
                        error={errors.name ? errors.name.message : ''}
                        defaultValue={itinerary.name}
                        name={nameof<ItineraryModel>('name')}
                        register={register}
                        options={{ required: Localization.getString('Itinerary name is required') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col type="100">
                    {stops?.length > 0 && <MapsRoutesPreview
                        apiKey={GLOBAL_SETTINGS.GOOGLE_MAPS_API_KEY}
                        value={stops}
                    />}
                </Col>
            </Row>
            <hr />
            <Container style={{ padding: '50px' }}>
                <h3>{Localization.getString('Itinerary stops')}:</h3>
                <Tooltip text={Localization.getString('Add stop')}>
                    <Buttons.ButtonSmallGreen onClick={onAddStop}>
                        <i className="fa fa-plus" />
                    </Buttons.ButtonSmallGreen>
                </Tooltip>

                {stops && stops.length > 0 ? (
                    stops.map((stop, index) => {
                        const fNames = getStopsFieldsNames(index)
                        return [
                            <Row key={`label-${stop.index}-${stop.guid}`}>
                                <Col type='100'>
                                    <label>Itinerary Stop #{stop.index}
                                        <i className='fa fa-trash float-right clickable' onClick={() => onDeleteStop(stop.index)} />
                                        {stop.index > 1 && <i className='fa fa-arrow-up float-right clickable' onClick={() => onStopUp(stop.index)} />}
                                        {stop.index < stops.length && <i className='fa fa-arrow-down float-right clickable' onClick={() => onStopDown(stop.index)} />}
                                    </label>
                                </Col>
                            </Row>,
                            <Row key={`${stop.index}.${index}-${stop.guid}`} id={`stop-${stop.index}`}>
                                <Col type="50">
                                    <Controller
                                        name={fNames.index}
                                        defaultValue={stops[index].index}
                                        control={control}
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                hidden
                                                value={stops[index].index}
                                                name="index"
                                                type="number"
                                                onChange={([e]: any) => parseInt(e.target.value, 10)}
                                            />
                                        )}
                                    />
                                    <TextFormField
                                        label={Localization.getString('Itinerary Stop Name')}
                                        isRequired
                                        error={
                                            errors.stops && errors.stops.length > 0 && !stop.name
                                                ? Localization.getString('itinerary stop name is required')
                                                : undefined
                                        }
                                        defaultValue={stops[index].name}
                                        name={fNames.name}
                                        register={register}
                                        options={{
                                            required: Localization.getString('itinerary stop name is required'),
                                        }}
                                    />
                                    <TextAreaField
                                        name={fNames.description}
                                        defaultValue={stop.description}
                                        label={`${Localization.getString("Description")}`}
                                        register={register}
                                    />
                                    <TimePickerFormFieldController
                                        name={fNames.timeDescription}
                                        defaultValue={stop.timeDescription}
                                        label={`${Localization.getString('Start Time')}`}
                                        error={
                                            errors[fNames.timeDescription]
                                                ? errors[fNames.timeDescription].message
                                                : ''
                                        }
                                        id={fNames.timeDescription}
                                        onChange={(e: string) => {
                                            setValue(fNames.timeDescription, e)
                                            setValue(fNames.time, timeStringToMinutes(e))
                                        }}
                                        control={control}

                                    />
                                    <TimePickerFormFieldController
                                        name={fNames.timeEndDescription}
                                        defaultValue={stop.timeEndDescription}
                                        label={`${Localization.getString('End Time')}`}
                                        error={
                                            errors[fNames.timeEndDescription]
                                                ? errors[fNames.timeEndDescription].message
                                                : ''
                                        }
                                        id={fNames.timeEndDescription}
                                        control={control}
                                        onChange={(e: string) => {
                                            setValue(fNames.timeEndDescription, e)
                                            setValue(fNames.timeEnd, timeStringToMinutes(e))
                                        }}

                                    />
                                    {/* <FormFieldLabel label={`Lat: ${stops[index].lat ?? 'N/A'}`} />
                                    <FormFieldLabel label={`Lng: ${stops[index].lng ?? 'N/A'}`} /> */}

                                    {/* <TextFormField
                                        label={Localization.getString('Stop lat')}
                                        defaultValue={stops[index].lat}
                                        name={fNames.lat}
                                        register={register}

                                    />
                                    <TextFormField
                                        label={Localization.getString('Stop lng')}
                                        defaultValue={stops[index].lng}
                                        name={fNames.lng}
                                        register={register}                                        
                                    /> */}
                                </Col>
                                <Col type="50">
                                    <Controller
                                        defaultValue={new MapsLocation("", stop.lat, stop.lng)}
                                        render={({ field }) => {
                                            const values = getValues()
                                            return <MapsLocationPicker
                                                apiKey={GLOBAL_SETTINGS.GOOGLE_MAPS_API_KEY}
                                                onChange={(value: MapsLocation) => {
                                                    field.onChange(value.address)
                                                    setValue(fNames.lat, value.lat ?? 0)
                                                    setValue(fNames.lng, value.lng ?? 0)
                                                    setLocationPhoto(fNames.mapLocationPhotoBase64, value)
                                                }}
                                                value={new MapsLocation(stop.address, stop.lat, stop.lng)}
                                            />
                                        }}
                                        name={fNames.address}
                                        control={control}
                                    />
                                    {(stop.mapLocationPhotoUrl || stop.mapLocationPhotoBase64)
                                        ? <>
                                            <span style={{ display: 'block' }}>Map Image</span>
                                            <img style={{ width: "120px" }} src={stop.mapLocationPhotoBase64 || stop.mapLocationPhotoUrl} alt="Location Map" />
                                        </>
                                        : null}
                                    <br /><hr />
                                    <MediaSelector
                                        heroImageId={stop.heroImageId}
                                        key={stop.guid}
                                        selected={stop.photos ? stop.photos.map(x => x.photo) : []}
                                        onSelectPhotos={(photos: Photo[]) => {
                                            onSelectStopPhotos(stop.guid, photos)
                                        }}
                                        onHeroImageChanged={(photo: Photo) => {
                                            setValue(fNames.heroImageId, photo.id)
                                            setValue(fNames.heroImage, photo)
                                        }}
                                        onDelete={(photo: Photo) => {
                                            onDeleteStopPhotos(stop.guid, photo.id)
                                        }}
                                    />
                                </Col>
                            </Row>,
                            <Row key={`${stop.index}.${index}.hr`}>
                                <Col type="100">
                                    <hr />
                                </Col>
                            </Row>,
                        ]
                    })
                ) : (
                    <FieldFooter
                        type="error"
                        error={
                            <>
                                <i className="fa fa-warning" />
                                {Localization.getString('Warning: Please add at least on stop')}
                            </>
                        }
                    />
                )}
                {stops && stops.length > 0
                    ? <Tooltip text={Localization.getString('Add stop')}>
                        <Buttons.ButtonSmallGreen onClick={onAddStop}>
                            <i className="fa fa-plus" />
                        </Buttons.ButtonSmallGreen>
                    </Tooltip>
                    : null}
            </Container>
            <Buttons.StickySaveButton>{Localization.getString('Save')}</Buttons.StickySaveButton>
        </form>
    </Grid>
}
export default ItineraryDesigner